import declare from "dojo/_base/declare";
import PathMatrix from "./Path";
import Spec from "csi/core/Spec";
import { Context } from "csi/def/Context";

export = declare(PathMatrix, {
	/**
	 * @override
	 * Fill in index into vector for each spec
	 */
	onPathSpecParams(ctx: Context, params: Partial<Spec>, columnIndex?: number): void {
		params.index = columnIndex;
	},
});